<template>
  <div class="invoice-create-bottom-grid">
    <slot name="left-card">
      <article v-if="!hideComments" class="invoice-create-card">
        <header class="invoice-create-card__head">
          <h3>
            <i class="fa fa-commenting-o invoice-create-section-icon invoice-create-section-icon--comments" aria-hidden="true"></i>
            {{ text.create.ui.bottomSection.commentsTitle }}
          </h3>
        </header>

        <div class="invoice-create-comments-box">
          <textarea
            v-if="!readOnly"
            :value="comments"
            class="invoice-create-comments"
            :placeholder="text.create.ui.bottomSection.commentsPlaceholder"
            @input="$emit('comments-change', $event?.target?.value || '')"
          ></textarea>
          <div v-else class="invoice-create-comments invoice-create-comments--readonly">{{ comments || emptyReadOnlyCommentsPlaceholder }}</div>
        </div>
      </article>
    </slot>

    <article class="invoice-create-card invoice-create-summary-card">
      <div v-if="showSubtotal" class="invoice-create-summary-row">
        <span>{{ generalText.financial.totals.subtotal }}</span>
        <div class="invoice-create-summary-value">
          <strong>{{ formatMoney(subtotal) }}</strong>
        </div>
      </div>

      <div v-if="showTransferredTaxes" class="invoice-create-summary-row">
        <span>{{ generalText.financial.taxes.transferred }}</span>
        <div class="invoice-create-summary-value">
          <strong>{{ formatMoney(transferredTaxAmount) }}</strong>
        </div>
      </div>

      <div v-if="showWithheldTaxes" class="invoice-create-summary-row">
        <span>{{ generalText.financial.taxes.withheld }}</span>
        <div class="invoice-create-summary-value">
          <strong>{{ formatMoney(withheldTaxAmount) }}</strong>
        </div>
      </div>

      <div class="invoice-create-summary-total">
        <span>{{ generalText.financial.totals.total }}</span>
        <div class="invoice-create-summary-value">
          <strong>{{ formatMoney(total) }}</strong>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';
import { formatCurrency } from '@/utils/numberFormat';

const { catalog: invoiceText } = useDomainText('invoices');
const { catalog: generalText } = useDomainText('general');

export default {
  name: 'InvoiceCreateBottomSection',
  props: {
    comments: {
      type: String,
      default: '',
    },
    discountRate: {
      type: Number,
      default: 0,
    },
    subtotal: {
      type: Number,
      default: 0,
    },
    discountAmount: {
      type: Number,
      default: 0,
    },
    transferredTaxAmount: {
      type: Number,
      default: 0,
    },
    withheldTaxAmount: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      default: 'MXN',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    hideComments: {
      type: Boolean,
      default: false,
    },
    showSubtotal: {
      type: Boolean,
      default: true,
    },
    emptyReadOnlyCommentsPlaceholder: {
      type: String,
      default: '-',
    },
  },
  emits: ['comments-change'],
  data() {
    return {
      text: invoiceText,
      generalText,
    };
  },
  computed: {
    showTransferredTaxes() {
      return Number(this.transferredTaxAmount || 0) > 0;
    },
    showWithheldTaxes() {
      return Number(this.withheldTaxAmount || 0) > 0;
    },
  },
  methods: {
    formatMoney(amount) {
      return formatCurrency(amount, { currency: this.currency });
    },
  },
};
</script>

<style scoped>
.invoice-create-comments--readonly {
  min-height: 108px;
  white-space: pre-wrap;
  cursor: default;
}
</style>
